import { localeNames } from '@internal/i18n/i18n'
import { TLocale } from '@internal/utils/machine/i18n/TLocale'
import { Select } from '@renderer-ui-library/atoms'
import { exposedLocales } from 'i18n/exposedLocales'
import { useLocalizedUrlMap } from 'i18n/useLocalizedUrlMap'
import { useRouter } from 'next/router'
import { memo, useCallback, useMemo } from 'react'
import { CountryFlag } from './CountryFlag'

type Props = {
  locale: TLocale
  longNames?: boolean
}

export const Locales: React.FC<Props> = memo(({ locale, longNames }) => {
  const localizations = useLocalizedUrlMap()

  const localeOptions = useMemo(() => {
    return exposedLocales.map((locale) => {
      const localeName = longNames ? localeNames[locale] : locale
      return {
        value: locale,
        key: localeName,
        iconComponent: <CountryFlag locale={locale} localeName={localeName} />,
      }
    })
  }, [longNames])

  const router = useRouter()
  const switchLocale = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const locale = event.target.value as TLocale
      router.push(localizations[locale], undefined, { locale: false })
    },
    [localizations, router]
  )

  return (
    <Select
      options={localeOptions}
      onChange={switchLocale}
      value={locale}
      noOutline={!longNames}
      fontSmall={!longNames}
    />
  )
})

Locales.displayName = 'Locales'
